"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _base = require("@mui/base");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _course = require("../../store/course");
var _Style = require("../../style/Style");
var _lesson = require("../../store/lesson");
var _user = require("../../store/user");
var _UserLesson = require("../../model/UserLesson");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    isLoading,
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    currentCourse,
    setCurrentCourse,
    setCurrentCourseById
  } = (0, _course.useCourseStore)();
  const {
    lessons,
    userLessons,
    fetchLessons,
    fetchUserLessons,
    deleteLesson,
    errors
  } = (0, _lesson.useLessonStore)();
  const {
    currentUser
  } = (0, _user.useUserStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      if (!props.id) {
        setLocation('/course');
        setToastText('コースが見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      if (!currentUser || !currentUser.id) {
        setToastText('ユーザー情報が見つかりませんでした。再度ログインしてください。');
        setToastOpen(true);
        setLocation('/login');
        return;
      }
      setIsLoading(true);
      await fetchLessons(props.id);
      await setCurrentCourseById(props.id);
      await fetchUserLessons(props.id, currentUser.id);
      setIsLoading(false);
    })();
  }, []);
  const StatusLabel = props => {
    if (!props.userLesson) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
    if (props.userLesson.isPassedExam) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.chipStyle.status, _Style.chipStyle.statusPassed),
        children: "\u4FEE\u4E86\u6E08"
      });
    } else {
      switch (props.userLesson.status) {
        case _UserLesson.UserLesson.STATUS_NOT_STARTED:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ...stylex.props(_Style.chipStyle.status, _Style.chipStyle.statusYet),
            children: "\u672A\u53D7\u8B1B"
          });
        case _UserLesson.UserLesson.STATUS_IN_PROGRESS:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ...stylex.props(_Style.chipStyle.status, _Style.chipStyle.statusDuring),
            children: "\u53D7\u8B1B\u4E2D"
          });
        case _UserLesson.UserLesson.STATUS_COMPLETED:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ...stylex.props(_Style.chipStyle.status, _Style.chipStyle.statusCompleted),
            children: "\u53D7\u8B1B\u6E08"
          });
        default:
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    ...stylex.props(_Style.wrapper.main),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
      ...stylex.props(_Style.buttonStyle.secondary),
      onClick: () => {
        window.history.back();
      },
      children: "\uFF1C\u623B\u308B"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "column",
      spacing: 3,
      sx: {
        width: '100%'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: currentCourse.thumbnailPreviewUrl,
        alt: currentCourse.name,
        ...stylex.props(_Style.imageStyle.courseDetail)
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
        container: true,
        justifyContent: 'space-between',
        direction: "row",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
          flexBasis: '40%',
          ...stylex.props(_Style.textStyle.h1),
          children: currentCourse.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
          flexBasis: '50%',
          ...stylex.props(_Style.textStyle.h3),
          children: currentCourse.detail
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "column",
      spacing: 3,
      sx: {
        width: '100%'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u6559\u6750\u4E00\u89A7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        container: true,
        direction: "row",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Stack, {
          direction: "row",
          spacing: 2,
          children: lessons.length > 0 ? lessons.map(lesson => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            direction: "column",
            justifyContent: "center",
            alignItems: 'center',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Link, {
              href: `/course/${currentCourse.id}/lesson/${lesson.id}`,
              ...stylex.props(_Style.textStyle.clearLinkDecoration),
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
                container: true,
                direction: "column",
                spacing: 1,
                ...stylex.props(_Style.wrapper.course),
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  ...stylex.props(_Style.wrapper.statusChip),
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: lesson.thumbnailPreviewUrl,
                    alt: lesson.name,
                    ...stylex.props(_Style.imageStyle.courseCard)
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StatusLabel, {
                    userLesson: lesson.id ? userLessons[lesson.id] : undefined
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  ...stylex.props(_Style.textStyle.h3),
                  children: lesson.name
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
                  container: true,
                  direction: "column",
                  spacing: 2,
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    ...stylex.props(_Style.textStyle.paragraph2),
                    children: lesson.detail
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
                    container: true,
                    direction: "column",
                    spacing: 0,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      ...stylex.props(_Style.textStyle.paragraph3),
                      children: ["\u6559\u6750\u306E\u6642\u9593: ", lesson.durationText]
                    })
                  })]
                })]
              })
            }), lesson.id && userLessons[lesson.id] && userLessons[lesson.id].isCompleted && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_base.Button, {
              ...stylex.props(_Style.buttonStyle.secondary),
              onClick: () => {
                setLocation(`/course/${currentCourse.id}/lesson/${lesson.id}/exam`);
              },
              children: [userLessons[lesson.id].isPassedExam && "再度", "\u4FEE\u4E86\u30C6\u30B9\u30C8\u3092\u53D7\u3051\u308B"]
            })]
          })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ...stylex.props(_Style.textStyle.p1b),
            children: errors.list || isLoading ? '読み込み中...' : '該当の教材が存在しません'
          })
        })
      })]
    })]
  });
};
var _default = exports.default = App;